import React, { FC } from 'react';
import clsx from 'clsx';
import { getFormattedNumberValue, VALUE_TYPE } from '../general-components/NumberFormatterComponent';

interface Props {
  maxValue: number;
  metric: number;
  type: VALUE_TYPE;
  additionalClass?: string;
  shorterNumberFormat?: boolean;
}
export const ProgressRange: FC<Props> = (props) => {
  const { maxValue, metric, type, additionalClass, shorterNumberFormat } = props;


  return (
    <div className={clsx('d-flex align-items-center', additionalClass)}>
      <div className="d-flex align-items-center">
        {type === 'amount' && '$'}
        {getFormattedNumberValue({ initialNumber: metric, type, shorterNumberFormat })}
        <span>/</span>
      </div>
      <div className="d-flex align-items-center ms-1">
        {type === 'amount' && maxValue !== null && '$'}
        {getFormattedNumberValue({ initialNumber: maxValue, type, isInfinity: true, shorterNumberFormat })}
      </div>
    </div>
  );
};